import React from 'react'
import PropTypes from 'prop-types'
import withLayout from '../../layout/withLayout'
import ContentBox from '../../layout/component/ContentBox'
import { lifecycle } from 'recompose'
import Row from '../../bootstrap/component/Row'
import Column from '../../bootstrap/component/Column'
import Table from '../../form/component/Table'
import worklistAttachmentColumnList from './worklist-attachment-column-list'

const WorklistAttachment = ({ taskListWithAttachment, tableSetting, changeTableSetting, navigateToTaskDetail, currentUserId}) => {
    return (
        <ContentBox title="Worklist Attachment">
            <Row>
                <Column size={12}>
                    <Table
                        columnList={worklistAttachmentColumnList(currentUserId)}
                        rowList={taskListWithAttachment}
                        changeTableSetting={changeTableSetting}
                        tableSetting={tableSetting}
                        idProperty="id"
                        onRowClick={(task) => {
                            navigateToTaskDetail(task.id)
                        }}
                    />
                </Column>
            </Row>
        </ContentBox>
    )
}


WorklistAttachment.propTypes = {
    taskListWithAttachment: PropTypes.array.isRequired,
    tableSetting: PropTypes.object.isRequired,
    changeTableSetting: PropTypes.func.isRequired,
    navigateToTaskDetail: PropTypes.func.isRequired,
    currentUserId: PropTypes.string.isRequired,
}

export default lifecycle({
    componentDidMount () {
        this.props.initialColumnsVisibility()
        this.props.findTaskListWithAttachment()
    },
})(withLayout(WorklistAttachment))



// WEBPACK FOOTER //
// ./src/modules/worklist-attachment/component/WorklistAttachment.js